import { render } from "./brand-edit.vue?vue&type=template&id=d8c0781c&scoped=true"
import script from "./brand-edit.vue?vue&type=script&lang=js"
export * from "./brand-edit.vue?vue&type=script&lang=js"

import "./brand-edit.vue?vue&type=style&index=0&id=d8c0781c&scoped=true&lang=css"

import exportComponent from "E:\\Projects\\YDN\\trunk\\zulin-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d8c0781c"]])

export default __exports__